<template>
  <div class="main-contain">
    <div class="restore-form">
      <AuIcon
        class="logo"
        :icon="logo"
      />
      <!-- Так криво и в лоб потому что если тупо выводить значение message лезет неясная бага с локализацией -->
      <div class="email-block">
        <span
          v-if="messageId===1"
          class="mb-2"
        >
          {{ $t("restore.inputEmail") }}
        </span>
        <span
          v-if="messageId===2"
          class="mb-2"
        >
          {{ $t("restore.newPassword") }}
        </span>
        <span
          v-if="messageId===3"
          class="mb-2"
        >
          {{ $t("restore.sendHash") }}
        </span>
        <span
          v-if="messageId===4"
          class="mb-2"
        >
          {{ $t("restore.wait") }}
        </span>
        <AuInput
          v-if="stage === 1"
          v-model="email"
        />
        <AuInput
          v-if="stage === 2"
          v-model="password"
          type="Password"
          :placeholder="$t(`login.password`)"
        />
        <AuInput
          v-if="stage === 2"
          v-model="passwordConfirm"
          class="mt-2"
          type="Password"
          :placeholder="$t(`login.passwordRepeat`)"
        />
      </div>
      <AuError
        class="mb-4"
        :error-msg="error"
      />
      <div class="button-place">
        <AuButton
          active-bg-color="#2aba7c"
          hovered-bg-color="#2aba7c"
          bordered
          border-color="black"
          font-color="white"
          font-size="12px"
          center
          height="55px"
          :is-progress="progress"
          @click="doAction"
        >
          {{ btnText }}
        </AuButton>
      </div>
    </div>
    <div
      v-if="stage !== 3"
      class="text-remember"
      @click="goToLogin"
    >
      {{ $t("restore.back") }}
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import AuInput from "@/components/extended/AuInput.vue";
import {
  containsLowercase, containsNumber,
  containsUppercase,
  email, minLength,
  requiredEmail,
  requiredPassword, sameAsPassword
} from "@/localization/localized-validators";
import { mapActions } from "vuex";
import { useVuelidate } from "@vuelidate/core";

export default {
  name: "PasswordRestore",
  components: { AuInput },
  props: {
    hash: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      v$: useVuelidate(),
      email: "",
      password: "",
      passwordConfirm: "",
      error: null,
      progress: false,
      stage: 1,
      messageId: 0
    };
  },
  validations() {
    return {
      email: { requiredEmail, email },
      password: {
        requiredPassword,
        containsUppercase,
        containsLowercase,
        containsNumber,
        minLength: minLength(8)
      },
      passwordConfirm: {
        sameAsPassword: sameAsPassword(this.password)
      }
    };
  },
  computed: {
    btnText() {
      return this.stage === 3 ? this.$t("restore.back") : this.$t("restore.next");
    },
    platform() {
      return process.env.VUE_APP_TITLE_FOOTER;
    },
    logo() {
      return process.env.VUE_APP_AUT_LOGO || "logo.v2";
    }
  },
  async mounted() {
    if (this.hash === "") {
      this.goToLogin();
    }
    if (this.hash === "restore") {
      this.messageId = 1;
    }
    else {
      this.stage = 2;
      this.messageId = 2;
    }
  },
  methods: {
    ...mapActions({
      restorePassword: "restorePassword",
      restoreRequestCheck: "restoreRequestCheck"
    }),

    checkEmail() {
      this.v$.email.$touch();
      const ret = _.find(this.v$.$errors, error => error.$propertyPath == "email");
      return ret?.$message ?? null;
    },

    checkPassword() {
      this.v$.password.$touch();
      this.v$.passwordConfirm.$touch();
      const ret = _.find(this.v$.$errors, error => error.$propertyPath == "password" || error.$propertyPath == "passwordConfirm");
      return ret?.$message ?? null;
    },

    async doAction() {
      switch (this.stage) {
        case 1: await this.sendHash(); break;
        case 2: this.sendPassword(); break;
        case 3: this.goToLogin(); break;
      }
    },

    goToLogin() {
      this.$router.push({ name: "login" });
    },

    async sendHash() {
      this.error = this.checkEmail();
      if (this.error) {
        return;
      }
      this.progress = true;
      try {
        await this.restorePassword(this.email);
        this.messageId = 3;
        this.stage = 3;
      }
      catch (e) {
        this.error = this.$t("restore.error") + e?.response.data?.errors;
      }
      this.progress = false;
    },

    async sendPassword() {
      this.error = this.checkPassword();
      if (this.error) {
        return;
      }
      this.progress = true;
      try {
        await this.restoreRequestCheck({ hash: this.hash, password: this.password });
        this.messageId = 4;
        this.stage = 3;
      }
      catch (e) {
        this.error = this.$t("restore.error") + e?.response.data?.errors;
      }
      this.progress = false;
    }
  }
};
</script>

<style scoped lang="scss">
.main-contain {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--main-color);
  height: 100vh;
  width: 100vw;
}
.restore-form {
  display: flex;
  flex-direction: column;

  width: 350px;
  height: min-content;

  background: var(--card-color);
  border: 1px solid var(--color-90);
  border-radius: 20px;
  padding: 20px;
}
.logo {
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
}
.email-block {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 20px;

  input {
    border-radius: 10px;
    border: 1px solid lightgray;
    padding: 15px;
    margin-bottom: 10px;
  }
  span {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: grey;
  }
}
.restore-error {
  text-align: center;
  font-size: 12px;
  color: red;
  margin-bottom: 5px;
}
.button-place {
  display: flex;
  flex-direction: column;
  // gap: 20px;s
}
.text-remember {
  color: grey;
  font-weight: 450;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  margin-top: 20px;
  text-decoration: underline;
}
</style>